import { c as _c } from "react/compiler-runtime";
import type React from 'react';
type IllustrationOnTheRightLayoutProps = {
  illustration: React.ReactNode;
  children: React.ReactNode;
};
export function IllustrationOnTheRightLayout(t0) {
  const $ = _c(7);
  const {
    illustration,
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="mx-auto max-w-xl">{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== illustration) {
    t2 = <div className="flex justify-center"><div className="w-full max-w-xl">{illustration}</div></div>;
    $[2] = illustration;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-2 lg:gap-16">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}